import PropTypes from 'prop-types';
import React from 'react';
import { Spacer } from 'src/core/components';

import ProductsTableContainer from '../../../ProductsTable/ProductsTableContainer';
import TableCardContainer from '../../../TableCard/TableCardContainer';

const OverviewComponent = ({ selectedMenuItem, setSelectedMenuItem, data }) =>
  data?.map((dataItem) =>
    dataItem?.subcategories?.map((subcategoryData) => {
      const category = {
        name: dataItem.category,
        categoryNr: dataItem.categoryNr,
      };
      const subcategory = {
        name: subcategoryData.name,
        subcategoryNr: subcategoryData.subcategoryNr,
      };

      return (
        <div key={subcategory.name}>
          <TableCardContainer
            {...{
              category: category.name,
              subcategory: subcategory.name,
              onViewAll: () =>
                setSelectedMenuItem({
                  category,
                  subcategory,
                  searchText: '',
                  filter: {},
                }),
              expanded:
                !subcategoryData.designs?.length ||
                selectedMenuItem?.searchText ||
                selectedMenuItem?.filter?.radioSelected,
            }}
          >
            <ProductsTableContainer
              selectedMenuItem={selectedMenuItem}
              category={category}
              subcategory={subcategory}
              products={subcategoryData.designs}
              isViewAllActive
            />
          </TableCardContainer>
          <Spacer top={40} />
        </div>
      );
    })
  );

OverviewComponent.propTypes = {
  data: PropTypes.array.isRequired,
  setSelectedMenuItem: PropTypes.func.isRequired,
  isViewAllActive: PropTypes.bool,
};

export default OverviewComponent;
